import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from 'app/services/loader.service';
import { PortfolioService } from '../portfolio/portfolio.service';

@Component({
  selector: 'app-add-apartment',
  templateUrl: './add-apartment.component.html',
  styleUrls: ['./add-apartment.component.css'],
  providers: [PortfolioService]
})
export class AddApartmentComponent implements OnInit {
  public createApartmentForm: FormGroup;
  city_list: any;
  states: any;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private portfolioService: PortfolioService,
    private loaderService : LoaderService 
  ) { }

  ngOnInit() {
    this.createApartmentForm = this.formBuilder.group({
      pincode: new FormControl("", [Validators.required]),
      area_name: new FormControl("", [Validators.required]),
      city: new FormControl("", [Validators.required]),
      state: new FormControl("", [Validators.required]),
      cluster: new FormControl("", [Validators.required]),
      apartment_name: new FormControl("", [Validators.required]),
      unid: new FormControl("", [Validators.required]),
      apartment_address: new FormControl("", [Validators.required]),
      developer_name: new FormControl("", [Validators.required]),
      area: new FormControl("", [Validators.required]),
      apartment_value: new FormControl("", [Validators.required]),
      lifestage: new FormControl("", [Validators.required]),
      theme: new FormControl("", [Validators.required]),
      start_from: new FormControl(""),
      format: this.formBuilder.array([this.createItem()])
    });
    this.getStates();
    this.getFilterData();
    this.getApartmentFormatData();
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl(""),
      variants: this.formBuilder.array([this.createVariantItem()]),
      // variant_id: new FormControl(""),
      // layout_image: new FormControl("")
    });
  }

  createVariantItem(): FormGroup {
    return this.formBuilder.group({
      variant_id: new FormControl(""),
      layout_image: new FormControl(""),
      primary_image: new FormControl("")
    });
  }

  pushJobAttributes(createApartmentForm) {
    
    return createApartmentForm.get('format').push(this.createItem())
  }

  addAnotherVariant(item) {
    
    item.get("variants").push(this.createVariantItem());
  }

  back() {
    this.router.navigate(['/list-apartment']);
  }

  getStates() {
    this.portfolioService.getStateList().subscribe(res => {
      this.states = res.state_list;
    })
  }
  getscityList(id) {
    this.portfolioService.getApartmentCity(id).subscribe(res => {
      this.city_list = res.Cities[id];
    })
  }
  theme: any;
  lifeStage: any;
  getFilterData() {
    this.portfolioService.getFilterData().subscribe(
      res => {
        this.lifeStage = res.lifestage;
        this.theme = res.theme;
      }
    );
  }

  formatData: any;
  getApartmentFormatData() {
    this.portfolioService.getFormatData().subscribe(res => {
      this.formatData = res.format;
    })
  }

  attachment_file: any;
  basefile = [];
  basefile3 = [];
  layoutimg1 = [];
  layoutimg2 = [];
  layoutimg3 = [];
  layoutimg4 = [];
  onChange(event,i,j) {
    
    this.attachment_file = event.srcElement.files[0];
    // if((this.attachment_file.size/1024) > 120) {
    //   document.getElementById('errorsize'+i).innerHTML = 'File size should not exceed 120kb.';
    // }
    if (i === 0) {
      var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        // this.basefile = base64.result;
        this.basefile = base64.result;
      
        this.layoutimg1.push(base64.result);
      };
    }
    if (i === 1) {
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile3 = base64.result;
        this.layoutimg2.push(base64.result);
      };
    }
    if (i === 2) {
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile3 = base64.result;
        this.layoutimg3.push(base64.result);
      };
    }
    if (i === 3) {
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile3 = base64.result;
        this.layoutimg4.push(base64.result);
      };
    }
    fileReader.readAsDataURL(this.attachment_file);
  }

  attachment_file2: any;
  basefile2 = [];
  basefile4 = [];
  primaryimg1 = [];
  primaryimg2 = [];
  primaryimg3 = [];
  primaryimg4 = [];
  onChangeImage(event,i,j) {
    this.attachment_file2 = event.srcElement.files[0];
    if (i === 0) {
      var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile2 = base64.result
        this.primaryimg1.push(base64.result);
      };
    }
    if (i === 1) {
      var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile4 = base64.result
        this.primaryimg2.push(base64.result);
      };
    }
    if (i === 2) {
      var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile4 = base64.result
        this.primaryimg3.push(base64.result);
      };
    }
    if (i === 3) {
      var fileReader = new FileReader();

      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        this.basefile4 = base64.result
        this.primaryimg4.push(base64.result);
      };
    }
    fileReader.readAsDataURL(this.attachment_file2);
  }

  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }

  msgError: boolean = false;
  errorMessage: string;
  successError: boolean = false;
  successMessage: string;
  onSubmit(data) {
    window.scrollTo(0,0); 
    console.log("Create Apartement Data", data);
    var arr = this.basefile;
    var arr2 = this.basefile2;
    // For inserting Layput and rpimary img into 1 format 
    if (data.format.length === 1) {
      if (data.format[0].variants.length === 1) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
      }
      else if (data.format[0].variants.length === 2) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
      }
      else if (data.format[0].variants.length === 3) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[2].layout_image = this.layoutimg1[2];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
        data.format[0].variants[2].primary_image = this.primaryimg1[2];
      }
    }

    // For inserting Layout and rpimary img into 2 format 

    if (data.format.length === 2) {
      if (data.format[0].variants.length === 1) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
      }
      if (data.format[0].variants.length === 2) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
      }
      if (data.format[0].variants.length === 3) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[2].layout_image = this.layoutimg1[2];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
        data.format[0].variants[2].primary_image = this.primaryimg1[2];
      }
      if (data.format[1].variants.length === 1) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
      }
      if (data.format[1].variants.length === 2) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
      }
      if (data.format[1].variants.length === 3) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[2].layout_image = this.layoutimg2[2];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
        data.format[1].variants[2].primary_image = this.primaryimg2[2];
      }
    }

    // For inserting Layout and Primary img into 3rd Format
    if (data.format.length === 3) {
      if (data.format[0].variants.length === 1) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
      }
      if (data.format[0].variants.length === 2) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
      }
      if (data.format[0].variants.length === 3) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[2].layout_image = this.layoutimg1[2];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
        data.format[0].variants[2].primary_image = this.primaryimg1[2];
      }
      if (data.format[1].variants.length === 1) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
      }
      if (data.format[1].variants.length === 2) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
      }
      if (data.format[1].variants.length === 3) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[2].layout_image = this.layoutimg2[2];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
        data.format[1].variants[2].primary_image = this.primaryimg2[2];
      }
      if (data.format[2].variants.length === 1) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
      }
      if (data.format[2].variants.length === 2) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[1].layout_image = this.layoutimg3[1];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
        data.format[2].variants[1].primary_image = this.primaryimg3[1];
      }
      if (data.format[2].variants.length === 3) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[1].layout_image = this.layoutimg3[1];
        data.format[2].variants[2].layout_image = this.layoutimg3[2];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
        data.format[2].variants[1].primary_image = this.primaryimg3[1];
        data.format[2].variants[2].primary_image = this.primaryimg3[2];
      }
    }

    // For inserting Layout and Primary img into 4th Format

    if (data.format.length === 4) {
      if (data.format[0].variants.length === 1) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
      }
      if (data.format[0].variants.length === 2) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
      }
      if (data.format[0].variants.length === 3) {
        data.format[0].variants[0].layout_image = this.layoutimg1[0];
        data.format[0].variants[1].layout_image = this.layoutimg1[1];
        data.format[0].variants[2].layout_image = this.layoutimg1[2];
        data.format[0].variants[0].primary_image = this.primaryimg1[0];
        data.format[0].variants[1].primary_image = this.primaryimg1[1];
        data.format[0].variants[2].primary_image = this.primaryimg1[2];
      }
      if (data.format[1].variants.length === 1) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
      }
      if (data.format[1].variants.length === 2) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
      }
      if (data.format[1].variants.length === 3) {
        data.format[1].variants[0].layout_image = this.layoutimg2[0];
        data.format[1].variants[1].layout_image = this.layoutimg2[1];
        data.format[1].variants[2].layout_image = this.layoutimg2[2];
        data.format[1].variants[0].primary_image = this.primaryimg2[0];
        data.format[1].variants[1].primary_image = this.primaryimg2[1];
        data.format[1].variants[2].primary_image = this.primaryimg2[2];
      }
      if (data.format[2].variants.length === 1) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
      }
      if (data.format[2].variants.length === 2) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[1].layout_image = this.layoutimg3[1];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
        data.format[2].variants[1].primary_image = this.primaryimg3[1];
      }
      if (data.format[2].variants.length === 3) {
        data.format[2].variants[0].layout_image = this.layoutimg3[0];
        data.format[2].variants[1].layout_image = this.layoutimg3[1];
        data.format[2].variants[2].layout_image = this.layoutimg3[2];
        data.format[2].variants[0].primary_image = this.primaryimg3[0];
        data.format[2].variants[1].primary_image = this.primaryimg3[1];
        data.format[2].variants[2].primary_image = this.primaryimg3[2];
      }
      if (data.format[3].variants.length === 1) {
        data.format[3].variants[0].layout_image = this.layoutimg4[0];
        data.format[3].variants[0].primary_image = this.primaryimg4[0];
      }
      if (data.format[3].variants.length === 2) {
        data.format[3].variants[0].layout_image = this.layoutimg4[0];
        data.format[3].variants[1].layout_image = this.layoutimg4[1];
        data.format[3].variants[0].primary_image = this.primaryimg4[0];
        data.format[3].variants[1].primary_image = this.primaryimg4[1];
      }
      if (data.format[3].variants.length === 3) {
        data.format[3].variants[0].layout_image = this.layoutimg4[0];
        data.format[3].variants[1].layout_image = this.layoutimg4[1];
        data.format[3].variants[2].layout_image = this.layoutimg4[2];
        data.format[3].variants[0].primary_image = this.primaryimg4[0];
        data.format[3].variants[1].primary_image = this.primaryimg4[1];
        data.format[3].variants[2].primary_image = this.primaryimg4[2];
      }
    }
    this.loaderService.display(true);
    this.portfolioService.createApartment(data).subscribe(res => {
      console.log(res);
      this.successError = true;
      this.successMessage = "Apartment Added Successfully !!!"
      setTimeout(function() {
        this.successError = false;
      }.bind(this), 5000);
      this.loaderService.display(false);
    },
        error => {
          this.msgError = true;
          this.errorMessage = "OOPS!!! Something Went Wrong."
          setTimeout(function() {
            this.msgError = false;
          }.bind(this), 5000);
      this.loaderService.display(false);
        })
  }


}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/add-apartment.component.ts